import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../Services';

@Component({
  selector: 'app-loginviatranscend',
  templateUrl: './loginviatranscend.component.html',
  styleUrls: ['./loginviatranscend.component.css']
})
export class LoginviatranscendComponent implements OnInit {
  
  Gtoken: any;
  Email: any;
  source: string;
  token: any;
  loading = false;
  Error = true;
  redirecturl: any;
  constructor(private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.Gtoken = params['token'];
      this.Email = params['email'];
      this.redirecturl = params['redirecturl'];
      
    });
    console.log(this.Gtoken);
    console.log(this.Email);
    this.loginExternal(this.Email, this.Gtoken)
    
  }
  loginExternal(email,GidToken) {
    
    
    this.authenticationService.loginExternal(email,GidToken)
        .subscribe(
        data => {
            if (data == null) {
                this.Error = false;
            }
            // store user details and jwt token in local storage to keep user logged in between page refreshes
  if (this.source != null && this.source != '') {
        this.token = data.access_token;
        var form: any = document.getElementById("frm");
        setTimeout(() => { window.setTimeout(form.submit()); }, 1000);
                   // setTimeout(() => { }), 20000);
                   
                   
                } else {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    window.localStorage.setItem('currentUser', JSON.stringify(data));
                    window.localStorage.setItem('id_token', data.access_token);
                   // this.authenticationService.loginTeam();
                   if (this.redirecturl != "")
                   {
                     console.log("Redircted url", this.redirecturl);
                       window.location.href = '/#/'+this.redirecturl;
                    }
                 else{
                       window.location.href = '/#/home';
                     }
                   // window.location.href='/#/home';
                    //this.router.navigate(['/home']);
                }            
         
        },
        error => {
            this.Error = false;
            this.loading = false;
            console.log("error occured: " + error);
        });

}
}



// WEBPACK FOOTER //
// ./src/app/loginviatranscend/loginviatranscend.component.ts